module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5YBTbp/media/FC-9781645367475.jpg?1685790454017",
      "alt": "This image is the cover for the book Treasure in Heaven: Live, Love, and Prosper"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Treasure in Heaven: Live, Love, and Prosper\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("Many people don’t understand how and why they make financial decisions. Most people believe the financial decisions they make today are separate from the spiritual results tomorrow. There is no spiritual savings account, checking account, or payment plan. Financial decision making often reflects the condition of the heart, mind, and soul.")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("Most people believe in financial shortcuts. They believe they can ‘hit the jackpot,’ ‘strike oil,’ ‘hit the mother lode,’ and that ‘our ship has come in.’ All those expressions represent an immediate expectation of wealth and prosperity. Many people believe that once wealth and prosperity are received, then satisfaction, happiness, and peace soon follow. Our daily decision-making can impact our spiritual savings. We should consider: What are our resources? Where does the Lord fit into our financial planning? How do I measure success?")])]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-right": "0cm",
      "margin-left": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "margin": "0cm",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("In "), _c('em', [_c('span', {
    staticStyle: {
      "font-family": "\"Arial Nova\",sans-serif"
    }
  }, [_vm._v("Treasure in Heaven: Live, Love, and Prosper,")])]), _vm._v(" the author explores how people make decisions. This book encourages people to engage in vertical communication with the Lord to improve the financial results in their lives. It encourages self-examination and the creation of a new definition of success and wealth.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christal Arthur\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "0mm",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Christal Arthur was born and raised in the rural Midwest. Raised on a family farm with 11 siblings, she is grateful for her family, educational opportunities, and her work associates who showed good work ethic, integrity, and sincerity in their approach to life.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0